<template name="detailIndex">
  <div :class="!overflowNotice && notice !== null ? 'overflow-hidden-notice' : 'show-invite-list'">
    <Top :isDetailPage="true" :trainingId="routId" @changeVisitListStatus="inviteListShow = true"></Top>
    <div class="container">
      <main>
        <div>
          <DetailTop ref="detailTop" @forWaringmodalShow="forWaringmodalStatus"></DetailTop>
        </div>
        <div class="content" :class="{'contain-content' : this.visitorDetailList  && this.visitorDetailList.length,'contain-z-index-show': this.editModal }" v-show="!isAddBtnClicked">
          <visitorList @addVisitor="handleAddVisitorDetail" ref="visitorLists" v-show="this.visitorDetailList && this.visitorDetailList.length"
          @editModalShow="editModalShow"
          @closeEditModal="closeEditModal"
          @showAlertModal="showAlertModal" :areaName="inviteData.areaName" :areaAddress="inviteData.areaAddress"></visitorList>
        </div>
        <div class="content contain-content add-visitor-detail-container" v-show="isAddBtnClicked">
          <i class="iconfont icon-close" @click="closeAddPop(true)" v-show="isAddBtnClicked && !showVisitorDetail"></i>
          <visitorDetailList :isKOSystem="false" :visitorDetailList="visitorInfoDetailList" @editVisitorDetail="handleAddOrEditVisitorDetail" v-show="!showVisitorDetail">

          </visitorDetailList>
          <div class="add-btn new-invite-title" v-show="visitorInfoDetailList.length < 5 && !showVisitorDetail && isAddBtnClicked && canAddOthersMaterial" @click="handleAddOrEditVisitorDetail">
            <i class="iconfont icon-add"></i>
            <span>
              {{$t('addVisitorInfo')}}
            </span>
            <span class="content-remarks">{{$t('5visitorsCanBeAdded')}}</span>
          </div>
          <div class="tab-container" v-show="showVisitorDetail && isAdd">
            <div class="tab-item" :class="{ 'checked-tab-item': tab.checked }"
              v-for="(tab, idx) in tabItems" v-if="idx==0" v-show="canAddMaterial" :key="idx" @click="handleSwitchVisitorDetail(idx)">
              {{ tab.tabName }}
            </div>
            <div class="tab-item" :class="{ 'checked-tab-item': tab.checked }"
              v-for="(tab, idx) in tabItems" v-if="idx==1" v-show="canAddOthersMaterial" :key="idx" @click="handleSwitchVisitorDetail(idx)">
              {{ tab.tabName }}
            </div>
            <i class="iconfont icon-close" @click="closeAddPop(false)" v-show="canAddOthersMaterial || canAddMaterial"></i>
          </div>
          <div class="add-visitor-detail-content" v-show="canAddMaterial ||  canAddOthersMaterial">
            <div class="component-wrapper">
              <addVisitorDetail
                :isKOSystem="false"
                :isExternalSystem="true"
                :isEditLoginVisitor="isEditLoginVisitor"
                :currentVisitor="currentVisitor"
                :materials="currentMaterials"
                :showVisitorDetail="showVisitorDetail"
                @answer="handleAnswer"
                @deleteImg="handleDeleteImg"
                @deleteAnnex="handleDeleteAnnex"
                @showContactSelect="handleShowContactSelect"
                @hideContactSelect="handleHideContactSelect"
                @saveCurrent="handleSaveCurrent"
                @clearCurrent="handleClearCurrent"
                @loadHistory="handleLoadHistory"
                @loadCompanyHistory="handleLoadCompanyHistory"
              >
              </addVisitorDetail>
            </div>
          </div>
          <div class="submit-container" v-show="isAddBtnClicked && !showVisitorDetail">
            <p v-show="privacy.hasPrivacyContent">{{$t('submittingThisForm')}}<a class="privacy-policy" @click="showPrivacy">{{ $t('PrivacyPolicy') }}</a></p>
            <button class="submit-visitor-detail" @click="showCommitModal">
              {{$t('submit')}}
            </button>
          </div>
        </div>
        <inviteListExternal v-if="inviteListShow" @changeVisitListStatus="inviteListShow = false"></inviteListExternal>
      </main>
      <footerMenuExternal :trainingId="routId" :isContactSelectShow="isContactSelectShow" :isDetailPage="true" @changeVisitListStatus="inviteListShow = true"></footerMenuExternal>
      <div class="addForWaringUser" v-show="this.forWaringmodal">
        <ForWaringUser @closeForwaring="closeForwaring" @comifrmModal="comifrmModal" :invitationId="this.routId" @isLoading="isLoadingShow"></ForWaringUser>
      </div>
      <div v-show="this.comifrmModalShow">
        <tipModal ref="detailDialogShow"  @closeModal="closeModal"></tipModal>
      </div>
      <footerExternal :isLoginPage="false"></footerExternal>
    </div>
    <loading :active.sync="isLoading" :color="'#e42029'" :z-index="9999"></loading>
    <!-- privacy -->
    <privacyModal
      :privacyContent="privacy.privacyContent"
      :privacyContentShow="privacy.privacyContentShow"
      @closePrivacy="privacy.privacyContentShow = false">
    </privacyModal>
    <!-- delete added visitor -->
    <alertModal :isModalShown="isDeleteModalShow" :modalTitle=
    "$t('confirmToDelete')"  @cancel="cancelDelete" @confirm="deleteVisitor"></alertModal>
    <!-- confirm commit -->
    <alertModal :isModalShown="isCommit" :modalTitle="$t('confirmToSubmit')" @cancel="isCommit = false" @confirm="commitData"></alertModal>
    <!-- confirm commited -->
    <alertModal modalType="simple" :isModalShown="isConfirm" :modalTitle="addSucess" @cancel="closeConfirmModal"></alertModal>
    <!-- edit commit -->
    <alertModal :isModalShown="isCommitEdit" :modalTitle="$t('confirmToSubmit')" @cancel="isCommitEdit = false" @confirm="commitEditData"></alertModal>
    <!-- confirm read notice -->
    <alertModal modalType="simple" v-if="notice !== null" :isModalShown="!inviteListShow && !overflowNotice" :modalTitle="$t('readTheDisclaimer')" @cancel="readNotice"></alertModal>
    <!-- confirm read notice -->
    <alertModal :modalType="'simple'" :isModalShown="isRemind" :modalTitle="carMessage" @cancel="isRemind = false"></alertModal>
    
    <alertModal :isModalShown="isRemind2" :modalTitle="$t('carInfoChange')" @cancel="isRemind2 = false" @confirm="commitEditData(true)"></alertModal>

    <alertModal :isModalShown="isRemind3" :modalTitle="$t('carInfoChange2')" @cancel="isRemind3 = false" @confirm="commitEditData(true)"></alertModal>

    <CarNumber ref="carNumber" v-show="this.canEditCarNumber"   @closeUpdateCarNumber="closeUpdateCarNumber" @saveCarNumber="saveCarNumber"></CarNumber>

    <alertModal modalType="simple" :isModalShown="isSaveCarNumberList"  :modalTitle="addSucess" @cancel="isCancelSaveCarNumber" ></alertModal>
    
    <alertModal modalType="simple" :isModalShown="isNoInvitationModalShow"  :modalTitle="noInvitationModalTitle" @cancel="handleLogout" ></alertModal>
  </div>
</template>

<script type="text/javascript">
import Top from '@/views/external/top.vue';
import DetailTop from '@/views/external/DetailTop.vue';
import {
  getInvitationOverview, getInvitationInfoExternal, getExternalMaterialOptions, getExternalLessonCategory,
  insertVisitors, loadHistroyExternalMaterialAnswers, getPrivacyPolicy, editVisitorMaterial, loadHistroyExternalCompanyAnswers,
} from '@/utils/api';
import { checkNested, scrollErrMsgToView } from '@/utils/utils';
import myAuth from '@/utils/auth';
import visitorList from '@/views/external/ExvisitorList.vue';
import ForWaringUser from '@/views/external/ForWaringUser.vue';
import inviteListExternal from '@/components/inviteListExternal.vue';
import addVisitorDetail from '@/components/addVisitorDetail.vue';
import visitorDetailList from '@/components/visitorDetailList.vue';
import footerExternal from '@/components/footerExternal.vue';
import footerMenuExternal from '@/components/footerMenuExternal.vue';
import alertModal from '@/components/alertModal.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import tipModal from '@/components/tipModal.vue';
import privacyModal from '@/components/privacyModal.vue';
import Materials from '@/utils/materials';
import CarNumber from '@/views/external/CarNumber.vue';
let materialsInstance = null;
import Bus from '@/utils/Bus';

export default {
  name: 'DetailIndex',
  components: {
    DetailTop,
    Top,
    visitorList,
    ForWaringUser,
    inviteListExternal,
    alertModal,
    addVisitorDetail,
    visitorDetailList,
    Loading,
    tipModal,
    footerExternal,
    footerMenuExternal,
    privacyModal,
    CarNumber,
  },
  data() {
    return {
      comifrmModalShow: false,
      routId: '',
      inviteData: {},
      editOneData: {},
      forWaringmodal: false,
      visitorDetailList:
        [
          {
            visitorId: 477,
            visitorName: '花花一',
            visitorPhoneNumber: '15722236665',
            visitorEmail: '',
            gender: null,
            isCoke: false,
            visitorStatus: 0,
            visitorStatusDesc: 'TicketUserVisitorStatus',
            isPriVisitor: true,
            isCurrentVisitor: true,
            materialApproverStatus: 4,
            materialApproverStatusDesc: '已审批',
            avatar: null,
            deptName: null,
            hasMaterial: true,
            qrCode: null,
            lessonList: [],
            materialOptionInfoList:
              [
                {
                  answer: '花花公子',
                  isCompany: true,
                  materialType: 3,
                  materialTitleTemplate: '公司名称',
                  materialAnswerTemplate: null,
                  optionCode: 1,
                  isSensitive: false,
                },
              ],
          },
          {
            visitorId: 477,
            visitorName: '花花一',
            visitorPhoneNumber: '15722236665',
            visitorEmail: '',
            gender: null,
            isCoke: false,
            visitorStatus: 0,
            visitorStatusDesc: 'TicketUserVisitorStatus',
            isPriVisitor: false,
            isCurrentVisitor: true,
            materialApproverStatus: 4,
            materialApproverStatusDesc: '已审批',
            avatar: null,
            deptName: null,
            hasMaterial: true,
            qrCode: null,
            lessonList: [],
            materialOptionInfoList:
              [
                {
                  answer: '花花公子',
                  isCompany: true,
                  materialType: 3,
                  materialTitleTemplate: '公司名称',
                  materialAnswerTemplate: null,
                  optionCode: 1,
                  isSensitive: false,
                },
              ],
          },
        ],
      inviteListShow: false,
      overflowNotice: false,
      /* Added by Andy */
      ticketId: 0,
      areaId: 0,
      typeId: 0,
      isLoading: false,
      showVisitorDetail: false,
      isAddBtnClicked: false,
      tabItems: [
        {
          tabName: this.$t('PersonalInfo'),
          isPersonal: true,
          canAddOthersMaterial: this.canAddOthersMaterial,
          canAddMaterial: this.canAddMaterial,
          checked: true,
        },
        {
          tabName: this.$t('OtherVisitors'),
          isPersonal: false,
          canAddOthersMaterial: this.canAddOthersMaterial,
          canAddMaterial: this.canAddMaterial,
          checked: false,
        },
      ],
      isContactSelectShow: false,
      isAdd: true,
      idx: -1,
      materials: [],
      currentMaterials: [],
      isPrimaryVisitor: true,
      isCurrentVisitorNoMaterials: false,
      isEditLoginVisitor: false,
      loginVisitor: null,
      currentVisitor: {
        id: 0,
        userName: '',
        pickedContact: this.$t('mobile'),
        contact: '',
        isPrimaryVisitor: true,
        materials: [],
        isPersonal: true,
      },
      visitorInfoDetailList: [],
      isDeleteModalShow: false,

      // submit
      isCommit: false,
      hasErrorCommitted: false,
      addSucess: this.$t('SubmittedSuccessfully'),
      isConfirm: false,
      isCommitEdit: false,
      editModal: false,
      notice: null,
      isReadNotice: false,
      privacy: {
        privacyContentShow: false,
        hasPrivacyContent: false,
        privacyContent: '',  
      },
      isNeedEffective: -1,
      canEditCarNumber: false,
      carId: '',
      visitorId: '',
      isSaveCarNumberList: false,
      sendUpdateCarObj: {},

      // if no invitation show tips and logout when user tap it
      isNoInvitationModalShow: false,
      noInvitationModalTitle: '',
      canAddOthersMaterial: false,
      canAddMaterial: false,
      memberRole: '',
      checkStatusTextOrigin: '',
      isRemind: false,
      carMessage: '',
      isRemind2: false,
      isRemind3: false,
      isCarrierTicket: false,
      
    };
  },
  watch: {
    $route() {
      if (this.$route.query.inviteList) {
        this.inviteListShow = true;
        this.overflowNotice = true;
      } else {
        this.inviteListShow = false;
        this.overflowNotice = false;
      }
      this.routId = this.$route.params.id;
      this.isNeedEffective = this.$route.params.isNeedEffective;
      this.publicFunction(this.routId, this.isNeedEffective);
    }
  },
  mounted(){
    const self = this;
    Bus.$on('carNumber', function (carId, status, visitorId, carNumberIsRequired) {
      self.canEditCarNumber = status;
      self.carId = carId;
      self.visitorId = visitorId;
      self.sendUpdateCarObj = {
        "ticketId": self.routId,
        "visitorId": self.visitorId,
        "carNumber": self.carId,
        "carNumberIsRequired": carNumberIsRequired,
      }
      self.$refs.carNumber.loadData(self.sendUpdateCarObj);
    })
  },
  created() {
    this.memberRole = myAuth.getLocalUserRole();

    if (this.$route.query.inviteList) {
      this.inviteListShow = true;
      this.overflowNotice = true;
    } else {
      this.inviteListShow = false;
      this.overflowNotice = false;
    }
    const routeID = this.$route.params.id;
    this.isNeedEffective = this.$route.params.isNeedEffective;
    this.routId = routeID;
    // top detail
    this.publicFunction(this.routId, this.isNeedEffective);

    getPrivacyPolicy().then((res) => {
      if (checkNested(res, 'data', 'content')) {
        if (res.data.content.model) {
          this.privacy.hasPrivacyContent = true;
          this.privacy.privacyContent = res.data.content.model;
        }
      }
    });
  },
  methods: {
    publicFunction(routeID, isNeedEffective) {
      this.isNoInvitationModalShow = false;
      this.noInvitationModalTitle = '';
      getInvitationOverview(routeID, isNeedEffective).then((res) => {
        if (res.data.content.status === 1) {
          if (checkNested(res, 'data', 'content', 'model')) {
            const inviteData = res.data.content.model;
            console.log('extenal detail', inviteData);
            const { areaId, typeId, invitationId, ifEnable, notice, isReadNotice, canForward, canAddOthersMaterial, canAddMaterial } = inviteData;
            this.inviteData = inviteData;
            console.log('inviteData', inviteData);
            this.checkStatusTextOrigin = this.inviteData.checkStatusText;
            this.areaId = areaId;
            this.typeId = typeId;
            this.ticketId = invitationId;
            this.$refs.detailTop.loadData(inviteData, ifEnable, canForward);
            this.notice = notice;
            this.isReadNotice = isReadNotice;
            if (routeID != this.ticketId) {
              if (this.ticketId) {
                this.$router.push({ path: `/external/detailIndex/${this.ticketId}/${isNeedEffective}` }); // redirect to effective one
              } else {
                this.isNoInvitationModalShow = true;
                this.noInvitationModalTitle = res.data.content.message;  
              }
            } else {
              this.commonFunction(routeID);
            }
            if(this.inviteData.isCarrierTicket) {
               this.isCarrierTicket = this.inviteData.isCarrierTicket;
             }
          }
        } else {
          this.isNoInvitationModalShow = true;
          this.noInvitationModalTitle = res.data.content.message;
        }
      });
    },
    handleLogout() {
      this.isNoInvitationModalShow = false;
      if (this.memberRole === '2') {
        this.$router.push({ path: "/external/carrier-new-application/0/0"});
      } else {
        myAuth.logoutExternal();
      }
    },
    commonFunction(routeID) {
      getInvitationInfoExternal(routeID).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          const inviteDtailList = res.data.content.model;
          console.log('inviteDtailList', inviteDtailList);
          this.visitorDtailList = inviteDtailList;
          if (this.inviteData) {
            const ifEnable = this.inviteData.ifEnable;
            const canAddOthersMaterial = this.inviteData.canAddOthersMaterial;
            const canAddMaterial = this.inviteData.canAddMaterial;
            this.$refs.visitorLists.loadData(inviteDtailList, ifEnable, canAddOthersMaterial, canAddMaterial, this.inviteData);
            const loginUser = inviteDtailList.find(x => x.isCurrentVisitor);
            this.isPrimaryVisitor = loginUser.isPriVisitor;
            this.loginVisitor = loginUser;
            this.isCurrentVisitorNoMaterials = loginUser.materialApproverStatus === 1;
          }
        }
      });

      getExternalLessonCategory(routeID).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          const lessonList = res.data.content.model;
          this.$refs.visitorLists.loadLesson(lessonList);
        }
      });

      // reset some data
      this.isAddBtnClicked = false;
      this.showVisitorDetail = false;
      this.visitorInfoDetailList = [];
    },
    forWaringmodalStatus(status) {
      this.forWaringmodal = status;
    },
    closeForwaring(status) {
      this.forWaringmodal = status;
    },
    /**
     * Added by Andy 19-04-09
     */
    handleSwitchVisitorDetail(idx) {
      this.tabItems = this.tabItems.map((t, index) => ({ ...t, checked: idx === index }));
      this.currentMaterials = materialsInstance.init();
      this.currentVisitor.isPersonal = this.tabItems.find(t => t.checked).isPersonal;
      this.currentVisitor.isPrimaryVisitor = this.currentVisitor.isPersonal ? this.isPrimaryVisitor : false;
      this.isEditLoginVisitor = this.currentVisitor.isPersonal;
      this.currentVisitor.userName = this.currentVisitor.isPersonal ? this.loginVisitor.visitorName : '';
      this.currentVisitor.pickedContact = this.currentVisitor.isPersonal ? (this.loginVisitor.visitorPhoneNumber ? this.$t('mobile') : this.$t('email')) : this.$t('mobile');
      this.currentVisitor.contact = this.currentVisitor.isPersonal ? (this.loginVisitor.visitorPhoneNumber || this.loginVisitor.visitorEmail) : '';
      this.currentVisitor.id = this.currentVisitor.isPersonal ? this.loginVisitor.visitorId : 0;
    },
    handleAddVisitorDetail(canAddOthersMaterial, canAddMaterial) { // red add btn
      console.log(` 获取权限${canAddOthersMaterial}, ${canAddMaterial}`)
      this.isAddBtnClicked = true;
      this.showVisitorDetail = !this.showVisitorDetail;
      this.isLoading = true;
      this.isAdd = true;
      this.canAddOthersMaterial = canAddOthersMaterial;
      this.canAddMaterial = canAddMaterial;
      if (this.isCurrentVisitorNoMaterials) {
        this.isEditLoginVisitor = true;
        this.currentVisitor = {
          id: this.loginVisitor.visitorId,
          userName: this.loginVisitor.visitorName,
          pickedContact: this.loginVisitor.visitorPhoneNumber ? this.$t('mobile') : this.$t('email'),
          contact: this.loginVisitor.visitorPhoneNumber || this.loginVisitor.visitorEmail,
          isPrimaryVisitor: this.isPrimaryVisitor,
          isPersonal: true,
          materials: [],
        };
      } else {
        this.isEditLoginVisitor = false;
        this.currentVisitor = {
          id: 0,
          userName: '',
          pickedContact: this.$t('mobile'),
          contact: '',
          isPrimaryVisitor: false,
          isPersonal: false,
          materials: [],
        };
      }
      this.tabItems = this.tabItems.map(t => ({ ...t, checked: this.currentVisitor.isPersonal === t.isPersonal }));

      getExternalMaterialOptions(this.areaId, this.typeId).then((res) => {
        this.isLoading = false;
        if (checkNested(res, 'data', 'content', 'model')) {
          // console.log(res.data.content.model);
          materialsInstance = new Materials(res.data.content.model);
          this.materials = materialsInstance.init();
          this.currentMaterials = materialsInstance.init();
        }
      });
    },
    closeAddPop(backToInit) {
      this.showVisitorDetail = false;
      if (backToInit) {
        this.isAddBtnClicked = false;
        this.visitorInfoDetailList = [];
      } else {
        this.isAddBtnClicked = this.visitorInfoDetailList.length;
      }
    },
    handleDeleteImg(data) {
      const materials = data.isPrimaryVisitor ? this.primaryVisitor.materials : this.currentMaterials;
      Materials.handleDeleteImgOrAnnex(data, materials);
    },
    handleDeleteAnnex(data) {
      const materials = data.isPrimaryVisitor ? this.primaryVisitor.materials : this.currentMaterials;
      Materials.handleDeleteImgOrAnnex(data, materials);
    },
    handleSaveCurrent() {
      let flag = true;
      const { isPrimaryVisitor } = this.currentVisitor;

      let materials = !isPrimaryVisitor ? this.currentMaterials.filter(m => !m.isCompany) : this.currentMaterials;
      materials.forEach((x) => {
        x.skipCheck = Materials.checkIfNeedToSkip(x, materials);
      });
      materials = Materials.checkIsRequiredFinished(materials, true); // true: param isForExternal = true
      flag = materials.findIndex(m => m.isError) === -1;
      // console.log(`flag: ${flag}`);
      if (flag) {
        this.currentVisitor.materials = this.currentMaterials.filter(x => !x.skipCheck && (isPrimaryVisitor || !x.isCompany)).map(m => ({ ...m }));
        if (this.isAdd) {
          this.visitorInfoDetailList = [...this.visitorInfoDetailList, this.currentVisitor];
        } else {
          this.visitorInfoDetailList = this.visitorInfoDetailList.map((x, idx) => (idx === this.idx ? this.currentVisitor : x));
        }
        this.showVisitorDetail = false;
      } else {
        scrollErrMsgToView('.add-visitor-detail-container');
      }
    },
    handleAddOrEditVisitorDetail(data) {
      this.showVisitorDetail = true;
      this.isNameEmpty = false;
      if (typeof data === 'number') {
        this.currentVisitor = Object.assign({}, this.visitorInfoDetailList[data]);
        this.currentMaterials = materialsInstance.init();
        this.currentVisitor.materials.forEach((m) => {
          const currentM = this.currentMaterials.find(x => x.id === m.id);
          currentM.answer = m.answer;
          currentM.trackId = m.trackId;
          currentM.names = m.names;
        });
        this.isAdd = false;
        this.idx = data;
        this.isEditLoginVisitor = this.currentVisitor.isPrimaryVisitor;
      } else {
        this.isAdd = true;
        this.idx = -1;
        const isPersonalNotAdded = this.isCurrentVisitorNoMaterials && this.visitorInfoDetailList.filter(v => v.isPersonal).length === 0;
        this.currentVisitor = {
          id: isPersonalNotAdded ? this.loginVisitor.visitorId : 0,
          userName: isPersonalNotAdded ? this.loginVisitor.visitorName : '',
          pickedContact: isPersonalNotAdded ? (this.loginVisitor.visitorPhoneNumber ? this.$t('mobile') : this.$t('email')) : this.$t('mobile'),
          contact: isPersonalNotAdded ? (this.loginVisitor.visitorPhoneNumber || this.loginVisitor.visitorEmail) : '',
          isPrimaryVisitor: isPersonalNotAdded ? this.isPrimaryVisitor : false,
          isPersonal: isPersonalNotAdded,
          materials: [],
        };
        this.currentMaterials = materialsInstance.init();
        this.isEditLoginVisitor = isPersonalNotAdded;
      }
      const { isPersonal } = this.currentVisitor;
      this.tabItems = this.tabItems.map(t => ({ ...t, checked: t.isPersonal === isPersonal }));
    },
    handleShowContactSelect() {
      this.isContactSelectShow = true;
      document.body.classList.toggle('modal-open');
    },
    handleHideContactSelect() {
      this.isContactSelectShow = false;
      document.body.classList.toggle('modal-open');
    },
    handleAnswer(data) {
      const materials = this.currentMaterials;
      Materials.handleAnswer(data, materials);
    },
    handleClearCurrent() {
      this.isDeleteModalShow = true;
      window.scrollTo(0, 0);
    },
    cancelDelete() {
      this.isDeleteModalShow = false;
    },
    deleteVisitor() {
      this.visitorInfoDetailList = this.visitorInfoDetailList.filter((x, index) => index !== this.idx);
      this.isDeleteModalShow = false;
      this.showVisitorDetail = false;
      this.isAddBtnClicked = this.visitorInfoDetailList.length ? this.isAddBtnClicked : false;
    },
    showCommitModal() {
      var newModel,
          newTon,
          newCarNum,
          curNum,
          curNumList,
          curType,
          curTypeList,
          curCarNum;
      console.log('currentMaterials', this.currentMaterials);
      this.currentMaterials.forEach(item => {
        if (item.optionCode == 7) {
          newModel = item.answer || '';
        }

        if (item.optionCode == 6) {
          newTon = item.answer || '';
        } 

        if (item.optionCode == 3) {
          newCarNum = item.answer || '';
        }
      });

      if (!newModel) {
        newModel = '';
      }
      if (!newTon) {
        newTon = '';
      }
      if (this.isCarrierTicket) {
        var log1 = false;
        var log2 = false;
        this.visitorDtailList.forEach(list => {
          if (list.materialOptionInfoList.find(v => v.optionCode == 3)) {
            curCarNum = list.materialOptionInfoList.find(v => v.optionCode == 3).answer || '';
          } else {
            curCarNum = '';
          }

          console.log('newCarNum1' + newCarNum, 'curCarNum2'+curCarNum);

          if (newCarNum && curCarNum) {
            // if car number is different.
            if (newCarNum != curCarNum ) {
              log1 = true;
              return
            }

            if (list.materialOptionInfoList.find(v => v.optionCode == 6)) {
              curNum = list.materialOptionInfoList.find(v => v.optionCode == 6).answer;
              if (curNum) {
                curNumList = list.materialOptionInfoList.find(v => v.optionCode == 6).materialAnswerTemplate;
                curNum = JSON.parse(curNumList)[JSON.parse(curNum)[0]];
              } else {
                curNum = ''
              }
            } else {
              curNum = ''
            }

            if (list.materialOptionInfoList.find(v => v.optionCode == 7)) {
              curType = list.materialOptionInfoList.find(v => v.optionCode == 7).answer
              if (curType) {
                curTypeList = list.materialOptionInfoList.find(v => v.optionCode == 7).materialAnswerTemplate;
                curType = JSON.parse(curTypeList)[JSON.parse(curType)[0]];
              } else {
                curType = ''
              }
            } else {
              curType = ''
            }
            console.log('curNum'+curNum, 'newTon'+newTon, 'curType'+curType, 'newModel' +newModel)
            if (curNum != newTon || curType != newModel) {
              log2 = true;
              return
            }
          }
        });
        
        if (log1) {
          this.isRemind = true;
          this.carMessage = this.$t('carInfoError1');
          return;
        }
        if (log2) {
          this.isRemind = true;
          this.carMessage = this.$t('carInfoError2');
          return;
        }
      }
      this.isCommit = true;
      window.scrollTo(0, 0);
    },
    showAlertModal(status, data) {
      // 修改显示弹窗
      console.log('data',data,'visitorDtailList',this.visitorDtailList );
      if (status) {
        var log1 = false;
        var log2 = false;
        var log3 = false;
        var curVisitorId = data.id;
        var num, numList, type, typeList, typeIndex, curNum, curType, newCarNumber, curCarNum;
        if (this.isCarrierTicket) {
          if (data.materials.find(v => v.optionCode == 3)) {
            newCarNumber = data.materials.find(v => v.optionCode == 3).answer || '';
          } else {
            newCarNumber = '';
          }

          if (data.materials.find(v => v.optionCode == 6)) {
            num =  data.materials.find(v => v.optionCode == 6).answer;
            if (num){
              numList = data.materials.find(v => v.optionCode == 6).materialAnswerTemplate;
              num = JSON.parse(numList).indexOf(num) + 1;
            } else {
              num = ''
            }
          } else {
            num = '';
          }

          if (data.materials.find(v => v.optionCode == 7)) {
            type = data.materials.find(v => v.optionCode == 7).answer;
            if (type){
              typeList = data.materials.find(v => v.optionCode == 7).materialAnswerTemplate;
              typeIndex = JSON.parse(typeList).indexOf(type) + 1;
            } else {
              typeIndex = ''
            }
          } else {
            typeIndex = '';
          }

          this.visitorDtailList.forEach(list => {

            if (list.materialOptionInfoList.find(v => v.optionCode == 3)) {
              curCarNum = list.materialOptionInfoList.find(v => v.optionCode == 3).answer || '';
            } else {
              curCarNum = '';
            }
            if (curCarNum && newCarNumber) {
              if (list.materialOptionInfoList.find(v => v.optionCode == 6)) {
                curNum = list.materialOptionInfoList.find(v => v.optionCode == 6).answer;
                if (curNum) {
                  curNum = JSON.parse(curNum)[0] + 1;
                } else {
                  curNum = '';
                }
              } else {
                curNum = ''
              }

              if (list.materialOptionInfoList.find(v => v.optionCode == 7)) {
                curType = list.materialOptionInfoList.find(v => v.optionCode == 7).answer;
                if (curType) {
                  curType = JSON.parse(curType)[0] + 1;
                } else {
                  curType = '';
                }
              } else {
                curType = ''
              }
              console.log('curNum='+curNum, 'num='+num, "typeIndex="+typeIndex, 'curType='+curType );
              console.log(curVisitorId, list.visitorId);
              if (curVisitorId != list.visitorId && (curNum != num || typeIndex != curType)) {
                log1 = true;
              }

              if (this.inviteData.checkStatus == 2 && (curNum != num || typeIndex != curType)) {
                log3 = true;
              }

              if (curCarNum != newCarNumber && curVisitorId != list.visitorId) {
                log2 = true;
              }
            }
          });
          if (log3) {
            this.isRemind3 = true;
            this.editOneData = data;
            return;
          }

          if (!newCarNumber) {
            this.isCommitEdit = true;
            this.editOneData = data;
            return;
          }

          if (log2) {
            this.isRemind = true;
            this.carMessage = this.$t('carInfoError1');
            return;
          }

          if (log1) {
            this.isRemind2 = true;
            this.editOneData = data;
            return;
          }
        }

        this.isCommitEdit = true;
      } else {
        this.isCommitEdit = false;
      }
      this.editOneData = data;
    },
    commitData() {
      this.isCommit = false;
      this.isRemind = false;
      const visitTicketInviteVisitors = [];
      const insertVisitorsModel = {
        ticketId: this.ticketId,
        visitTicketInviteVisitors: [],
      };
      const temp = this.visitorInfoDetailList;
      temp.forEach((x) => {
        const user = {};
        let postMaterials = [];
        user.userName = x.userName;
        user.id = x.id; // trackId
        user.isPrimaryVisitor = x.isPrimaryVisitor;
        if (x.pickedContact === this.$t('mobile')) {
          user.phoneNumber = x.contact;
          user.email = '';
        } else {
          user.email = x.contact;
          user.phoneNumber = '';
        }
        x.materials.forEach((m) => {
          m.skipCheck = Materials.checkIfNeedToSkip(m, x.materials);
        });
        postMaterials = Materials.checkIsRequiredFinishedBeforePost(x.materials);
        if (postMaterials.length) {
          postMaterials = x.materials.filter(m => (typeof m.answer === 'string' ? m.answer : (m.answer !== null && m.answer.length)) && !m.skipCheck);
        }
        user.visitTicketVisitorMaterials = postMaterials.map(y => ({
          id: y.trackId,
          materialOptionId: y.id,
          answer: Materials.handleAnswerForPost(y),
        }));
        visitTicketInviteVisitors.push(user);
      });
      insertVisitorsModel.visitTicketInviteVisitors = visitTicketInviteVisitors;
      this.isLoading = true;
      // console.log(JSON.stringify(insertVisitorsModel));
      insertVisitors(insertVisitorsModel).then((res) => {
        this.isLoading = false;
        if (res.data.content && res.data.content.status === 1) {
          this.hasErrorCommitted = false;
          this.addSucess = this.$t('addedSuccessfully');
        } else {
          this.addSucess = res.data.content.message;
          this.hasErrorCommitted = true;
        }
        this.isConfirm = true;
      });
    },
    commitEditData(Tag) {
      this.isCommitEdit = false;
      this.isRemind = false;
      this.isRemind2 = false;
      this.isRemind3 = false;
      const user = this.editOneData;

      let postMaterials = [];
      user.materials.forEach((m) => {
        m.skipCheck = Materials.checkIfNeedToSkip(m, user.materials);
      });
      postMaterials = user.materials.filter(m => (typeof m.answer === 'string' ? m.answer : (m.answer !== null && m.answer.length)) && !m.skipCheck);
      postMaterials= user.isPrimaryVisitor ? postMaterials : postMaterials.filter(x => !x.isCompany);
      user.visitTicketVisitorMaterials = postMaterials.map(y => ({
        id: y.trackId,
        materialOptionId: y.id,
        answer: Materials.handleAnswerForPost(y),
      }));
      const currentVisitorData = {
        "visitorId": user.id,
         "userName": user.userName,
         "materials": user.visitTicketVisitorMaterials,
         "isCover": Tag || false
      }
      this.isLoading = true;
      // console.log(JSON.stringify(currentVisitorData));
      editVisitorMaterial(currentVisitorData).then((res) => {
        this.isLoading = false;
        if (res.data.content && res.data.content.status === 1) {
          this.hasErrorCommitted = false;
          this.addSucess = this.$t('updatedSuccessfully');
        } else {
          this.addSucess = res.data.content.message;
          this.hasErrorCommitted = true;
        }
        this.isCommitEdit = false;
        this.isConfirm = true;
      });
    },
    closeConfirmModal() {
      if (this.hasErrorCommitted) {
        this.isCommit = false;
        this.isConfirm = false;
      } else {
        window.location.reload();
      }
    },
    bindHistoryData(model) {
      const materials = this.currentMaterials;
      Materials.bindHistoryMaterialsData(model, materials);
    },
    handleLoadHistory() {
      const phone = this.currentVisitor.pickedContact === this.$t('mobile') ? this.currentVisitor.contact : '';
      const email = this.currentVisitor.pickedContact === this.$t('email') ? this.currentVisitor.contact : '';
      if (phone || email) {
        this.isLoading = true;
        loadHistroyExternalMaterialAnswers(phone, email).then((res) => {
          this.isLoading = false;
          if (checkNested(res, 'data', 'content', 'model')) {
            this.bindHistoryData(res.data.content.model);
          }
        });
      }
    },
    handleLoadCompanyHistory(data) {
      if (data.companyName) {
        loadHistroyExternalCompanyAnswers(data.companyName).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            this.bindHistoryData(res.data.content.model);
          }
        });
      }
    },
    showPrivacy() {
      this.privacy.privacyContentShow = true;
    },
    editModalShow(status) {
      this.editModal = status;
    },
    closeEditModal(status) {
      this.editModal = status;
    },
    comifrmModal(status, data) {
      this.comifrmModalShow = status;
      this.$refs.detailDialogShow.loadDialogData(data);
    },
    closeModal() {
      this.comifrmModalShow = false;
    },
    readNotice() {
      this.gotoNotice = true;
      document.body.classList.remove('modal-open');
      this.$router.push({
        path: `/external/notice/${this.routId}`,
      });
    },
    isLoadingShow(status) {
      this.isLoading = status;
    },
    closeUpdateCarNumber(status) {
      this.canEditCarNumber = status;
    },
    saveCarNumber(status, message, canEditCarNumber) {
      this.canEditCarNumber = canEditCarNumber;
      this.isSaveCarNumberList = status;
      this.addSucess = message;
      window.scrollTo(0, 0);
      document.body.style.overflow='hidden';
    },
    isCancelSaveCarNumber() {
      this.isSaveCarNumber = false;
      window.location.reload();
    }
  },
};
</script>
<style lang="scss" scoped>
  @import "../../scss/variables.scss";
  .show-invite-list {
    overflow: auto;
    .detail-header {
      //position: relative;
    }
    main {
      padding: 80px 0;
      @include respond-to('sm-max') {
        padding: 58px 0 0 ;
      }
      @include respond-to('ml') {
        padding: 58px 0 0;
      }
    }
  }
  .content {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    margin-top: 0;
    position: relative;
    z-index: 10;
    float: left;
    margin-left: 31px;
    &.contain-z-index-show {
      z-index: 1040;
    }
    &.contain-content {
      width: 530px;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
      margin-bottom: 15px;
    }
    @include respond-to('sm-max') {
      float: none;
      width: 100%;
      margin-top: -10px;
      margin-left: 0;
      &.contain-content {
        width: 100%;
        margin-bottom: 75px;
     }
    }
    @include respond-to('ml') {
      float: none;
      width: 100%;
      margin-top: -10px;
      margin-left: 0;
      &.contain-content {
        width: 100%;
        margin-bottom: 75px;
     }
    }
  }
  .addForWaringUser {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 1200;
    background:rgba(0, 0, 0, 0.4);
  }
  .addBtn {
    width: 317px;
    height: 46px;
    margin: 0 auto 30px;
    @include respond-to('sm-max') {
      display: block;
      width: 100%;
      padding: 20px 29px 0;
      margin-left: 0;
    }
    @include respond-to('ml') {
      display: block;
      width: 100%;
      padding: 20px 29px 0;
      margin-left: 0;
    }
    .addInformation {
      width: 100%;
      margin: 20px auto 0;
      background-image: linear-gradient(81deg, #f36443, #e42029);
      height: 46px;
      text-align: center;
      color: #fff;
      line-height: 46px;
      border-radius: 5px;
      margin-top: 0px;
      cursor: pointer;
      i {
        margin-right: 7px;
      }
      span {
        font-size: 15px;
        font-weight: 600;
        color: #fff;
      }
    }
  }
  .add-visitor-detail-container {
    .icon-close {
      position: absolute;
      right: 2px;
      top: 0;
      font-size: 24px;
    }
    padding-top: 16px;
    .add-btn {
      padding: 12px;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
      margin: 20px 16px 0 16px;
      border-radius: 4px;
    }
    .tab-container {
      display: flex;
      justify-content: space-around;
      font-size: 15px;
      color: #4a4a4a;
      cursor: pointer;
      position: relative;
      .tab-item {
        padding: 5px 0;
        &.checked-tab-item {
          color: #e42029;
          border-bottom: 3px solid;
        }
        @include respond-to('lg') {
          padding: 15px 0;
        }
      }
      .icon-close {
        position: absolute;
        right: 5px;
        top: 0px;
        font-size: 24px;
      }
    }
    .add-visitor-detail-content {
      padding:  0  30px 45px;
      .component-wrapper {
        @include respond-to('lg') {
          box-shadow: none;
        }
        box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
      }
      .add-visitor-detail {
        .visitor-detail-wrapper {
          border: 1px solid #e42029;
        }
      }
    }
  }
  .submit-container {
    display: flex;
    flex-direction: column;
    padding: 16px 16px 60px;
    @include respond-to('lg') {
      align-items: flex-end;
      button {
        width: 218px;
      }
    }
    p {
      font-size: 12px;
      color: #929292;
      text-align: center;
      margin: 40px 0 10px;
      .privacy-policy {
        cursor: pointer;
        color:#e42029;
      }
    }
    button {
      border: none;
      line-height: 40px;
      color: #fff;
      background-image: linear-gradient(81deg, #f36443, #e42029);
      border-radius: 5px;
    }
  }
  .overflow-hidden-notice {
    overflow: hidden;
    height: 100vh;
  }
</style>
